<template lang="html">
  <modal
    name="purchase-modal"
    height="auto"
    width="416"
    :adaptive="true"
    :maxWidth="416"
    class="purchase-modal"
    @before-open="loading = false"
  >
    <div class="modal-container">
      <div class="modal-header bold">
        Renew Build+ Subscriptions
      </div>
      <div class="line-break" />
      <div class="modal-body">
        <div class="error-message" v-if="error">
          {{error}}
        </div>
        <CreditCardForm :stripe="stripePublicKey" />
        <div class="gap-3x" />
        <div class="flex-box">
          <div class="description-section">
            <div class="bold total">Total</div>
          </div>
          <div class="price-section">
            <div class="bold total">${{total}}</div>
          </div>
        </div>
        <div class="gap-1x" />
        <div class="small-text">
          {{note}}
        </div>
      </div>
      <div class="line-break" />
      <ModalFooter
        rightActionText="Purchase"
        :cancel="() => $modal.hide('purchase-modal')"
        :save="purchase"
        :rightActionLoading="loading"
      />
    </div>
  </modal>
</template>

<script>
import ModalFooter from './shares/ModalFooter.vue'

import CreditCardForm from 'src/components/common/CreditCardForm.vue'
import EventBus from 'src/components/EventBus.js'

export default {
  components: { CreditCardForm, ModalFooter },
  props: {
    "total": {
      type: Number,
    },
    "note": {
      type: String,
    },
    "paymentReadyCallback": {
      type: Function,
      default: () => {}
    },
    "error": {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      loading: false,
      couponCode: null,
    }
  },
  methods: {
    purchase() {
      if(this.loading) return;
      this.loading = true;
      EventBus.$emit('checkout-cc', this.paymentReadyCallback)
    },
    onPaymentNotReady() {
      this.loading = false
    }
  },
  computed: {
    stripePublicKey() {
      return process.env.VUE_APP_STRIPE_PUBLIC_KEY;
    }
  },
  created() {
    EventBus.$on('payment-not-ready', this.onPaymentNotReady)
  },
  beforeDestroy() {
    EventBus.$off('payment-not-ready', this.onPaymentNotReady)
  }
}
</script>

<style lang="scss">

.purchase-modal {
  select.number-of-licenses {
    width: 100%;
    margin-bottom: 144px !important;
  }

  .modal-body {
    padding-top: 0 !important;
  }

  .description-section {
    flex-grow: 1;
  }

  .price-section {
    text-align: right;

    .prorated-savings {
      color: #00A992;
    }
  }

  .total {
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.18px;
  }

  .note {
    font-size: 12px;
    line-height: 16px;
  }

  .oval-button {
    float: none;
    font-family: Inter;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.07px;
    padding: 8px 16px;
  }

  .cancel-section {
    flex-grow: 1;
    text-align: left;
  }

  .continue-add-user {
    min-width: 96px;
  }

  .credit-card-inputs {
    display: block;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.08px;
    color: #21275B;

    .question-group {
      margin: 0;
      width: 100%;

      .element-container {
        width: auto;
      }

      &.cvc, &.expires {
        width: calc(50% - 12px);
        display: inline-block;
      }

      &.expires {
        margin-right: 24px;
      }
    }
  }
}
</style>
